import { useQuery } from "@tanstack/react-query";
import { AuditDetailModel } from "models";
import { getAuditDetails } from "services/auditService";

export const auditDashboardAuditDetailsQueryKey = (
  storeId: string | null | undefined,
  auditId: string | null | undefined
) => ["audit-dashboard-audit-details", storeId, auditId] as const;

export function useAuditDashboardAuditDetails(
  storeId: string | null | undefined,
  auditId: string | null | undefined,
  enabled = true
) {
  return useQuery<AuditDetailModel | null, Error>({
    queryKey: auditDashboardAuditDetailsQueryKey(storeId, auditId),
    queryFn: () => getAuditDetails(storeId!, auditId!),
    enabled: Boolean(enabled && storeId && auditId),
  });
}
